import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { ProjectModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[ProjectSetup] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[ProjectSetup] Load items success', props<{ data: PaginationAdapter<ProjectModel> }>());

// item
export const loadItem = createAction('[ProjectSetup] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[ProjectSetup] Load item success', props<{ item: ProjectModel }>());
